export const flow = {
	title: "Cash Flow Extract",
	filename: "cash-flow-extract",
	emptyText: "There is nothing to show for the selected period",
	anticipated: "Anticipated",
	table: {
		date: "Settlement date",
		competency: "Transaction date",
		title: "Description",
		value: "Value",
		balance: "Balance",
	},
};
